import CryptoJS from 'crypto-js';

const passphrase = 'ippEncryption';

export const encrypt = (text: string) => {
  return CryptoJS.AES.encrypt(text, passphrase).toString();
};

export const decrypt = (ciphertext: string | null) => {
  if (!ciphertext) return '';
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (err) {
    console.error('Decryption failed:', err);
    return '';
  }
};
